import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

enum servicesCode {
    IS_DRESSING_ROOM = 'IS_DRESSING_ROOM',
    TRYING_ON = 'TRYING_ON',
    PART_DELIV = 'PART_DELIV',
    BAN_ATTACHMENT_INSPECTION = 'BAN_ATTACHMENT_INSPECTION',
    REVERSE = 'REVERSE',
    DELIV_RECEIVER = 'DELIV_RECEIVER',
    DANGER_CARGO = 'DANGER_CARGO',
    SMS = 'SMS',
    NOTIFY_ORDER_CREATED = 'NOTIFY_ORDER_CREATED',
    NOTIFY_ORDER_DELIVERY = 'NOTIFY_ORDER_DELIVERY',
    COURIER_PACKAGE_A2 = 'COURIER_PACKAGE_A2',
    THERMAL_MODE = 'THERMAL_MODE',
    GET_UP_FLOOR_BY_HAND = 'GET_UP_FLOOR_BY_HAND',
    GET_UP_FLOOR_BY_ELEVATOR = 'GET_UP_FLOOR_BY_ELEVATOR',
    LOADING_OPERATIONS_AT_THE_SENDER = 'LOADING_OPERATIONS_AT_THE_SENDER',
    LOAD_THE_OPERATION_AT_THE_RECIPIENT = 'LOAD_THE_OPERATION_AT_THE_RECIPIENT',
}

const servicesDict: Array<Dictionary> = []

for (const code in servicesCode) {
    servicesDict.push({
        code: code,
        name: i18n.t(`dictionary.services.${code}`).toString()
    })
}
export { servicesDict, servicesCode }
